// Modal "Điều chỉnh Xu": cộng/trừ tay có ghi chú bắt buộc. clientUuid sinh MỖI LẦN MỞ ⇒ bấm lưu 2 lần không cộng đôi.
import { useEffect, useState } from "react";
import { Alert, Input, InputNumber, Modal, message } from "antd";
import xuProgramApi from "../../../api/xuProgramApi";
import { apiError, fmtNum } from "./xu-format-helpers";

const MAX_ADJUST = 1000000;

export default function XuAdjustModal({ open, userId, balance, onClose, onDone }) {
    const [delta, setDelta] = useState(null);
    const [note, setNote] = useState("");
    const [uuid, setUuid] = useState("");
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (open) {
            setDelta(null);
            setNote("");
            setUuid(window.crypto.randomUUID());
        }
    }, [open]);

    const valid = Number.isInteger(delta) && delta !== 0 && note.trim().length >= 3;
    const after = Math.max(0, balance + (delta || 0));

    const submit = async () => {
        setSaving(true);
        try {
            await xuProgramApi.adjust(userId, { delta, note: note.trim(), clientUuid: uuid });
            message.success("Đã điều chỉnh Xu");
            onDone();
        } catch (e) {
            message.error(apiError(e, "Điều chỉnh thất bại"));
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal
            open={open}
            title={`Điều chỉnh Xu cho #${userId}`}
            okText="Xác nhận điều chỉnh"
            cancelText="Huỷ"
            okButtonProps={{ disabled: !valid }}
            confirmLoading={saving}
            onOk={submit}
            onCancel={onClose}
            destroyOnClose
        >
            <Alert className="mb-3" type="info" showIcon message="Mọi điều chỉnh được ghi vào sổ Xu kèm tên admin và lý do, không sửa được về sau." />
            <div className="mb-1 font-medium">Số Xu (số dương = cộng, số âm = trừ)</div>
            <InputNumber
                className="w-full mb-3"
                min={-MAX_ADJUST}
                max={MAX_ADJUST}
                precision={0}
                value={delta}
                onChange={setDelta}
                addonAfter="Xu"
                placeholder="Ví dụ: 500 hoặc -200"
            />
            <div className="mb-1 font-medium">Lý do (bắt buộc)</div>
            <Input.TextArea value={note} maxLength={255} showCount rows={3} onChange={(e) => setNote(e.target.value)} placeholder="Ví dụ: Bù Xu do lỗi nhiệm vụ ngày 30/10 theo khiếu nại" />
            {valid && (
                <div className="mt-3">
                    Số dư: <b>{fmtNum(balance)}</b> → <b>{fmtNum(after)}</b> Xu
                    {balance + delta < 0 && <span className="text-orange-600"> (không trừ quá số dư, chỉ trừ tới 0)</span>}
                </div>
            )}
        </Modal>
    );
}
